import { Injectable } from "@angular/core";
import {
  PluginInjectorService,
  IMenuItem,
  PluginInjectorApplicationPlugin,
  IMenuItemPermissions,
} from "core-client/api";
import { faUserGear } from "@fortawesome/free-solid-svg-icons";
import { MatDialog } from "@angular/material/dialog";
import { BehaviorSubject } from "rxjs";
import { PLUGIN_MODULE_PERMISSIONS } from "../shared/permissions.constant";

@Injectable({
  providedIn: "root",
})
export class AdministrationService {
  private navbarMenuItem!: IMenuItem;
  private readonly navbarMenuTitle: string = "ADMINISTRATION";
  private readonly pluginModule: string = "ADMINISTRATION";
  private menuItemPermissions: IMenuItemPermissions;

  constructor(public pluginInjectorService: PluginInjectorService) {
    this.menuItemPermissions = {
      administration: JSON.parse(
        JSON.stringify(PLUGIN_MODULE_PERMISSIONS.administration),
      ),
    };
  }

  getNavbarMenuItem(
    pluginConfig: PluginInjectorApplicationPlugin.IApplicationPlugin,
    dashboardMenu: IMenuItem[],
    primaryEnabled: boolean,
    secondaryEnabled: boolean,
  ): IMenuItem[] {
    const menuItemsPermissionsRefs = this.getMenuItemPermissionRefs();

    const menuExist = dashboardMenu.some(
      (menuItem: IMenuItem) =>
        menuItem.nameIdentifier.toLowerCase() ===
        this.navbarMenuTitle.toLowerCase(),
    );

    this.navbarMenuItem = {
      pluginId: pluginConfig._id,
      pluginName: pluginConfig.name,
      pluginModule: this.pluginModule,
      nameIdentifier: this.navbarMenuTitle,
      accessRights: menuItemsPermissionsRefs,
      primary: {
        enabled: primaryEnabled,
        position: dashboardMenu.length + 1,
      },
      secondary: {
        enabled: secondaryEnabled,
        position: dashboardMenu.length + 1,
      },
      strictMode: true,
      headerSortOrder: 50,
      icon: faUserGear,
      dropdown: false,
      disabled: new BehaviorSubject(false),
      callback: async (dialog: MatDialog, id?: string) => {
        await this.openMenuDialog(pluginConfig._id, dialog, id);
      },
    };

    if (!menuExist) {
      dashboardMenu.push(this.navbarMenuItem);
    }

    return dashboardMenu;
  }

  private getMenuItemPermissionRefs(): string[] {
    let menuItemsPermissionsRefs: string[] = [];

    for (const menuItemFlag in this.menuItemPermissions) {
      const menuItemsKeys = Object.values(
        this.menuItemPermissions[menuItemFlag],
      );

      menuItemsPermissionsRefs = [
        ...new Set(
          menuItemsKeys.flatMap((obj) =>
            Object.entries(obj)
              .filter(([key, value]) => value === false)
              .map(([key]) => key),
          ),
        ),
      ];
    }

    return menuItemsPermissionsRefs;
  }

  getMenuItemPermissions(): IMenuItemPermissions {
    return this.menuItemPermissions;
  }

  private async openMenuDialog(
    pluginId: string,
    dialog: MatDialog,
    id?: string,
  ): Promise<void> {
    const lazyComponent = await import(
      "./navbar-menu-item/navbar-menu-item.component"
    );
    const dialogConfig = this.pluginInjectorService.getMenuDialogConfig();

    dialog.open(lazyComponent.NavbarMenuItemComponent, {
      ...dialogConfig,
      panelClass: ["adx-plugin-default-dialog-content", "adx-dialog-large"],
      // Fixed: the width would otherwise follow the open tab.
      width: "1000px",
      data: {
        id: id,
        pluginId: pluginId,
        pluginModule: this.pluginModule,
      },
    });
  }
}
